export const APP_STORE_URL =
  'https://apps.apple.com/uk/app/hugo-energy-app/id1571912897';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.hugoeneryapp.prod';
